      //tester tool script
                           const customTextInput = document.querySelector('#\\#custom--text');
                     const productTitleInput = document.getElementById('product-title-input');

                     customTextInput.addEventListener('input', () => {
                       if (parseInt(customTextInput.value) > 50) {
                         productTitleInput.classList.add('new-class'); // Add your desired class name
                       } else {
                         productTitleInput.classList.remove('new-class'); // Remove the class if value is not greater than 50
                       }
                     });


                         $("#slider").on("input",function () {
                                     $('#product-title-input').css("font-size", $(this).val() + "px");
                             });

                     const weightSlider = document.getElementById('weight-slider');
               const boldText = document.querySelector('#product-title-input');

               weightSlider.addEventListener('input', () => {
                 const sliderValue = parseInt(weightSlider.value);
                 if (sliderValue > 50) {
                   boldText.style.fontWeight = 'bold';
                 } else {
                   boldText.style.fontWeight = 'normal';
                 }
               });
                const productTitleInputn = document.getElementById('product-title-input');
           const cbtTool = document.querySelector('.cbt-tool');
           let isClassAdded = false;

           cbtTool.addEventListener('click', () => {
             if (isClassAdded) {
               productTitleInputn.classList.remove('custom-weight-new');
             } else {
               productTitleInputn.classList.add('custom-weight-new');
             }
             cbtTool.classList.toggle('custom-weight-new-all');
             isClassAdded = !isClassAdded;
           });


function setTextAlignment(align) {
         const productTitleInputa = document.getElementById('font-sampler-preview');
         const fatLeft = document.querySelector('.fat--left');
         const fatCenter = document.querySelector('.fat--center');
         const fatRight = document.querySelector('.fat--right');

         productTitleInputa.style.textAlign = align;

         // Add and remove classes based on the clicked alignment button
         switch (align) {
           case 'left':
             fatLeft.classList.add('active');
             fatCenter.classList.remove('active');
             fatRight.classList.remove('active');
             break;
           case 'center':
             fatLeft.classList.remove('active');
             fatCenter.classList.add('active');
             fatRight.classList.remove('active');
             break;
           case 'right':
             fatLeft.classList.remove('active');
             fatCenter.classList.remove('active');
             fatRight.classList.add('active');
             break;
           default:
             break;
         }
       }
const slider = document.getElementById('slider');
const tooltip = document.querySelector('.tooltip-call');

slider.addEventListener('input', function () {
  const value = this.value;
  const rect = slider.getBoundingClientRect();
  const sliderWidth = rect.width;
  const tooltipWidth = tooltip.clientWidth;

  const tooltipLeft = ((value - slider.min) / (slider.max - slider.min)) * (sliderWidth - tooltipWidth);
  tooltip.style.left = `${tooltipLeft}px`;

  tooltip.textContent = value;

  tooltip.style.display = 'block';
});

slider.addEventListener('change', function () {
  tooltip.style.display = 'none';
});



       //keyboard--tool

                  const keyLetters = document.querySelectorAll('.key-l');
        const selectedKeyContainer = document.getElementById('selected-key');

        keyLetters.forEach(key => {
            key.addEventListener('mouseenter', () => {
                const keyValue = key.textContent;
                selectedKeyContainer.textContent = `${keyValue}`;
            });

            key.addEventListener('click', () => {
                const keyValue = key.textContent;
                selectedKeyContainer.textContent = `${keyValue}`;
            });

            key.addEventListener('mouseleave', () => {
            });
        });

$(function() {
    // Hide all accord-content except the first one
    $('.accord-content').hide().first().show();

    // Toggle the accord-content when the associated .accord--new is clicked
    $('.accord--new').on('click', function() {
        $(this).next().slideToggle("slow");
    });
});


    // $('.accord--new').on('click',function () {
    //     $('.accord-content').toggleClass('clicked-new');
    // });

        const accordNewa = document.querySelector('.accord--new');
        const images = document.querySelectorAll('.accord--new img');

        let rotated = false;

        accordNewa.addEventListener('click', function() {
            rotated = !rotated;
            images.forEach(image => {
                image.classList.toggle('rotate', rotated);
            });
        });


//seller grid and list
function handleRadioChange(radio) {
  const smsResultWrap = document.querySelector('.sms-result--wrap');

  if (radio.id === 'radio2') {
    radio.classList.add('checked');
    smsResultWrap.classList.add('radio2-checked');
    document.querySelector('.sms--list').classList.remove('selected');
  } else {
    radio.classList.add('checked');
    smsResultWrap.classList.remove('radio2-checked');
    document.querySelector('.sms--list').classList.add('selected');
    document.getElementById('radio2').classList.remove('checked');
  }
}
//sellers search bar javascript

  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("search-input");
    const suggestionsList = document.getElementById("suggestions");
    const collectionList = document.getElementById("collection-list-new");
    const collectionItems = collectionList.querySelectorAll("li");

    searchInput.addEventListener("input", function () {
      const searchTerm = searchInput.value.trim().toLowerCase();
      suggestionsList.innerHTML = ""; // Clear previous suggestions

      collectionItems.forEach(function (item) {
        const itemTitle = item.querySelector("a").textContent.toLowerCase();
        const isApproved = item.dataset.approved === "yes";

        if (itemTitle.includes(searchTerm) && isApproved) {
          const suggestionItem = document.createElement("li");
          suggestionItem.textContent = itemTitle;
          suggestionsList.appendChild(suggestionItem);
        }
      });

      if (suggestionsList.children.length > 0) {
        suggestionsList.style.display = "block";
      } else {
        suggestionsList.style.display = "none";
      }
    });
  });

//product main image slider 
  // $(document).ready(function() {
  //   $('.slider-pro').slick({
  //     // Slick slider options and settings go here
  //     dots: true,
  //     infinite: true,
  //     speed: 500,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     nextArrow: '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0096/9349/5356/files/right-arrow_4_3.png?v=1697890544"></button>',
  //    prevArrow: '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0096/9349/5356/files/right-arrow_4_2.png?v=1697890548"></button>'
  //   });
  // });



 


//font-weight

 // JavaScript to handle variant selection
var variant = document.getElementById('variant-select');

 if(variant != null){
    variant.addEventListener('change', function() {
    var selectedVariant = this.value;
    var productTitleInput = document.getElementById('product-title-input');
    
    // Update the font-weight based on the selected variant
    switch (selectedVariant) {
      case 'regular':
        productTitleInput.style.fontWeight = 'normal';
        break;
      case 'medium':
        productTitleInput.style.fontWeight = '500';
        break;
      case 'bold':
        productTitleInput.style.fontWeight = 'bold';
        break;
      default:
        break;
    }
  }); 
 }
  